// extracted by mini-css-extract-plugin
export var columnList = "_b1-0";